import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.module.scss';
import BooleanStatus from 'components/Details/BooleanStatus';
import Rating from 'components/Details/Rating';
import MultiIcon from 'components/MultiIcon';
import MapArray from 'components/Details/MapArray';
import MapMarker from './MapMarker';
import MapCompound from './MapCompound';
import ListData from './ListData';
// import PhoneRegistration from './PhoneRegistration';
import ProgressBar from './ProgressBar';
import Media from './Media';
import TripLocations from './TripLocations';
import { displayTime } from 'utils/time';
import ServiceInfo from './ServiceInfo';
import { LOCATION_MODE } from 'utils/constants/Map';
import Evidence from './Evidence';
import Schedule from './Schedule';
import { DEFAULT_DATE_FORMAT } from 'utils/constants';
import MultiImageUpload from 'components/Forms/Fields/MultiMediaUpload';
import ImageMarker from './ImageMarker';
import BooleanStatusColour from './BooleanStatusColour';
import { t } from 'i18next';
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';

const WithTextTypography = withStyles(theme => ({
  root: {
    color: theme.palette.text.primary,
    display: 'flex',
    flexDirection: 'column',
  },
}))(Typography);

const checkIfMoreThanTwoStrings = val => {
  const arr = val.split(',');
  // If the values is like 'Cleaner' then convert it
  if (arr.length === 1) {
    return t(arr[0]);
  }
  let concatenatedString = '';
  // if the string is like 'Manager, Responder'
  for (const key in arr) {
    if (Object.hasOwnProperty.call(arr, key)) {
      concatenatedString += t(arr[key].trim());
      if (parseInt(key, 10) !== arr.length - 1) {
        concatenatedString += ',';
      }
    }
  }
  return concatenatedString;
};

const valueType = ({
  type,
  value,
  customLabelValue,
  center,
  additionalPolygon,
  boundryList,
  additionalPolygonMode,
  imageUrl,
  label,
}) => {
  switch (type) {
    case 'text':
      return (
        <WithTextTypography className={styles.detailInfoText}>
          {customLabelValue
            ? customLabelValue
            : Array.isArray(value)
            ? String(value)
            : value}
        </WithTextTypography>
      );
    case 'textTranslated':
      return (
        <WithTextTypography className={styles.detailInfoText}>
          {checkIfMoreThanTwoStrings(value)}
        </WithTextTypography>
      );
    case 'textArea':
      return (
        <WithTextTypography className={styles.detailInfoText}>
          {value}
        </WithTextTypography>
      );
    case 'dynamic-text-generator':
      return (
        <WithTextTypography className={styles.detailInfoText}>
          {value && value?.map(m => m.title).toString()}
        </WithTextTypography>
      );

    case 'select':
      return (
        <WithTextTypography className={styles.detailInfoText}>
          {t(value)}
        </WithTextTypography>
      );
    case 'async-select':
      return (
        <WithTextTypography className={styles.detailInfoText}>
          {t(value)}
        </WithTextTypography>
      );

    case 'date-picker':
      return (
        <WithTextTypography className={styles.detailInfoText}>
          {displayTime({ timestamp: value })}
        </WithTextTypography>
      );

    case 'date':
      return (
        <WithTextTypography className={styles.detailInfoText}>
          {value
            ? displayTime({ timestamp: value, format: DEFAULT_DATE_FORMAT })
            : '-'}
        </WithTextTypography>
      );

    case 'boolean':
    case 'toggle':
    case 'boolean-select':
      return <BooleanStatus value={value} className={styles.detailImage} />;

    case 'boolean-color':
      return (
        <BooleanStatusColour value={value} className={styles.detailImage} />
      );
    case 'rating':
      return <Rating value={value} reliability />;

    case 'icons':
      return <MultiIcon value={value} label={label} />;

    case 'map-array':
      return <MapArray value={value} />;

    case 'map-marker':
      return (
        <MapMarker
          value={value}
          center={center}
          additionalPolygon={additionalPolygon}
          boundryList={boundryList}
          additionalPolygonMode={additionalPolygonMode}
        />
      );

    case 'map-compound':
      return <MapCompound value={value} />;

    case 'media':
      return <Media value={value} />;
    case 'detailImageTable':
      return (
        <div className={styles.paddingMultiImageUpload}>
          <MultiImageUpload
            allowDeleteRow={false}
            allowEditRow={false}
            allowDelete={false}
            value={value}
          />
        </div>
      );
    case 'array':
      return (
        <WithTextTypography>
          {value.length > 0
            ? value.map((v, key) => (
                <div className={styles.detailInfoText} key={key}>
                  {v.display}
                </div>
              ))
            : '-'}
        </WithTextTypography>
      );
    case 'list-data':
      return <ListData data={value.data} col={value.columns} />;
    // case 'phone-registration':
    //   return <PhoneRegistration status={value} id={id} />;
    case 'progress-bar':
      return <ProgressBar value={value} />;
    case 'icon-with-label':
      return <MultiIcon value={value.id} label={t(value.value)} />;
    case 'trip-locations':
      return <TripLocations value={value} />;
    case 'service-info':
      return <ServiceInfo value={value} />;
    case 'evidence':
      return <Evidence value={value} />;
    case 'schedule':
      return <Schedule value={value} />;
    case 'image-boolean':
      return <BooleanStatus value={value} />;
    case 'image-marker':
      return (
        <ImageMarker
          value={value}
          imageUrl={imageUrl}
          boundryList={boundryList}
        />
      );
    default:
      return null;
  }
};
valueType.propTypes = {
  type: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.array,
    PropTypes.bool,
  ]),
  additionalPolygon: PropTypes.array,
  boundryList: PropTypes.array,
  additionalPolygonMode: PropTypes.oneOf(Object.values(LOCATION_MODE)),
};
export default valueType;
